var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.$emit('back')}}},[_vm._v(_vm._s(_vm.backLabel))]),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.disableNext},on:{"click":function($event){return _vm.$emit('next')}}},[_vm._v(" "+_vm._s(_vm.nextLabel)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }